import React from 'react';
import styles from './point-mini-card.module.scss';
import { IPointMiniCardDto } from 'shared/api/business/interfaces/point-mini-card-dto.interface';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { CircleImage } from '../circle-image/circle-image';
import { useAppMediaQuery } from 'shared/hooks';

export interface IPointMiniCardProps {
  pointInfo: IPointMiniCardDto;
}

export const PointMiniCard: React.FC<IPointMiniCardProps> = ({ pointInfo }) => {
  const isMobile = useAppMediaQuery('mobileL');
  const navigate = useNavigate();

  const handleNavigateClick = () => {
    const path = AppLinks.PointLink.replace(':id', String(pointInfo.id));
    navigate(path);
  };
  return (
    <div className={styles.point_card__container} onClick={handleNavigateClick}>
      <div className={styles.card__info}>
        <div className={styles.info__title}>
          <CircleImage
            imgSize={isMobile ? 40 : 50}
            imgSrc={pointInfo.logoUrl}
          />
          <div className={styles.title__name}>{pointInfo.name}</div>
        </div>
        <div className={styles.info__address}>{pointInfo.address}</div>
        {pointInfo?.administrator ? (
          <div className={styles.info__admin}>
            <CircleImage
              imgSrc={pointInfo.administrator.imgUrl}
              imgSize={isMobile ? 30 : 35}
            />
            <div className={styles.admin__name}>
              {pointInfo?.administrator?.fio}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
